import React, { Component, PureComponent } from 'react'
import { ThunkDispatch } from 'redux-thunk';
import classNames from 'classnames';
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import { styles } from '../containers/dockPadStyle'
import { compose } from 'redux'
import DialogActions from '@material-ui/core/DialogActions';
import { connect } from 'react-redux'
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import ButtonBase from '@material-ui/core/ButtonBase';
import { Typography } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import { phasePlanActions } from '../actions/phaseplan.actions';
import { getOffDays } from '../selectors/phaseplan.selector'

export interface Props {
    classes: ClassNameMap,
    onDayClicked: (index: number) => Promise<void>,
    value: number
}

const DayPicker : React.FunctionComponent<Props> =
({ classes, onDayClicked, value }) => {

    const days = [
        'Mon',
        'Tues',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun'
    ]

    const onHandleChange = (index: number) => {
        return async () => {
            onDayClicked(index)
        }
    }

    const renderDay = (day: string, index: number) => {
        return (
            <ButtonBase>
                <div>
                    <Typography>
                        {day}
                    </Typography>
                    <Checkbox checked={value === index}  onChange={onHandleChange(index)} />
                </div>
            </ButtonBase>
        )
    }

    return (
        <div className={classes.WeekdayPickerContainer}>
            {days.map((day, index) => renderDay(day, index))}
        </div>
    )
}

export default compose(
    withStyles(styles, { withTheme: true }),
)(DayPicker);


// WEBPACK FOOTER //
// ./src/components/DayPicker.tsx